<template>
    <div>
        <h4>{{ `${selectedRows.length} records selected` }}</h4>

        <div class="action-selection">
            <h5>Select action type:</h5>
            <div class="action-options">
                <div
                    v-for="(action, index) in bulkActions"
                    :key="index"
                    :class="['action-option', { selected: selectedActionIndex === index, disabled: !action.enabled }]"
                    @click="action.enabled && selectAction(index)"
                >
                    <md-icon>{{ action.icon }}</md-icon>
                    <span>{{ action.name }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChooseBulkAction',
    props: {
        selectedRows: {
            type: Array,
            required: true
        },
        selectedActionIndex: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            bulkActions: [
                { name: 'Assign to Driver', icon: 'person_pin', enabled: true },
                { name: 'Change Status', icon: 'swap_horiz', enabled: true },
                { name: 'Add Stop Note', icon: 'note_add', enabled: true },
                { name: 'Delete', icon: 'delete', enabled: true },
                { name: 'Unassign', icon: 'person_remove', enabled: true },
                { name: 'Set Date', icon: 'edit_calendar', enabled: true }
            ]
        };
    },
    methods: {
        selectAction(index) {
            this.$emit('action-selected', index);
        }
    }
};
</script>

<style lang="scss" scoped>
.search-criteria {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    margin: 15px 0;

    .search-criteria-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 15px;
        background-color: #f5f5f5;
        cursor: pointer;

        h5 {
            margin: 0;
        }
    }

    .search-criteria-content {
        padding: 15px;

        .criteria-item {
            margin-bottom: 8px;
        }
    }
}

.action-selection {
    margin-top: 20px;

    .action-options {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        margin-top: 10px;

        .action-option {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 120px;
            height: 120px;
            border: 2px solid #e0e0e0;
            border-radius: 8px;
            padding: 15px;
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover:not(.disabled) {
                border-color: #2196f3;
                background-color: rgba(33, 150, 243, 0.05);
            }

            &.selected {
                border-color: #2196f3;
                background-color: rgba(33, 150, 243, 0.1);
            }

            &.disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }

            .md-icon {
                font-size: 36px;
                margin-bottom: 10px;
            }

            span {
                text-align: center;
            }
        }
    }
}
</style>
